<div *ngIf="config && config.layers && config.layers.length > 0" style="padding: 10px">
    <merkator-layer-control [map]="mapService.mapRef" [config]="config"
    [fontSizeTitle]="'24px'" [multiExpanded]="false">
    </merkator-layer-control>
</div>